import { useEffect, useState } from 'react';
import PropTypes from 'prop-types';

import { getsessionStorageData } from '../../lib';
import { sessionStorageKeys } from '../../constants';
import './popUpNew.css';
import { FaChevronRight } from 'react-icons/fa';
import { Modal } from 'components/common/modal';

const popUpNew = ({
    props: {
        isDesktopOrMobile,
        popupTemplate,
        image: imageUrl,
        imagePosition,
        animation,
        primaryColor,
        title,
        titleColor,
        description,
        descriptionColor,
        buttonText,
        buttonColor,
        buttonTextColor,

        popUpDateTime,
        popUpDateTimeISO,
        closeAutomaticaly,
        closeOption,
        closeAutoSeconds,
        hasClickCount,
        clickCount,
        hasExitIntent,
        hasPageCount,
        pageCount,
        hasPageScroll,
        pageScrollPercent,
        hasShadow,
        hasTimeDelay,
        timeDelay,
        popupID,
        popupWidth,
        popupHeight,
        popupOpenInterval,
        buttonLink,
        buttonBehavior,
        closeButtonColor,
        dateTextColor,
        dateBackColor,
    },
}) => {
    const closedOfferPopups = getsessionStorageData(
        sessionStorageKeys.CLOSED_OFFER_POPUPS,
        []
    );

    //  let initialState;

    // if (popupOpenInterval === 'Everytime') {
    //     initialState = true;
    // } else {
    //     initialState = closedOfferPopups.indexOf(popupID) === -1;
    // }

    // const [isOpen, setIsOpen] = useState(initialState);
    const [isOpen, setIsOpen] = useState(false);

    const closePopup = () => {
        if (
            closedOfferPopups.indexOf(popupID) === -1 &&
            popupOpenInterval !== 'Everytime'
        ) {
            closedOfferPopups.push(popupID);
            sessionStorage.setItem(
                sessionStorageKeys.CLOSED_OFFER_POPUPS,
                JSON.stringify(closedOfferPopups)
            );
        }
        setIsOpen(false);
    };

    const popupCntStyles = {
        height: popupHeight,
        width: popupWidth,
    };

    let isMobileClass = '';
    if (isDesktopOrMobile === 1) {
        isMobileClass = 'ab-popup-new-is-mobile';
    }

    let mobileClass = '';
    if (isDesktopOrMobile === 1) {
        mobileClass = '-mobile';
    }

    const [days, setDays] = useState(0);
    const [hours, setHours] = useState(0);
    const [minutes, setMinutes] = useState(0);
    const [seconds, setSeconds] = useState(0);
    const [autoClose, setautoClose] = useState(false);

    if (autoClose && closeAutomaticaly) {
        closePopup();
    }

    const timeObj = () => {
        const dateString = `${popUpDateTimeISO}`;
        const date = new Date(dateString);

        const dateNow = new Date();
        let seconds = Math.floor((date - dateNow) / 1000);
        if (Math.floor(seconds) > 0) {
            let minutes = Math.floor(seconds / 60);
            let hours = Math.floor(minutes / 60);
            const days = Math.floor(hours / 24);
            hours = hours - days * 24;
            minutes = minutes - days * 24 * 60 - hours * 60;
            seconds =
                seconds - days * 24 * 60 * 60 - hours * 60 * 60 - minutes * 60;

            timeObj.days = days;
            timeObj.hours = hours;
            timeObj.minutes = minutes;
            timeObj.seconds = seconds;
        } else {
            timeObj.days = 0;
            timeObj.hours = 0;
            timeObj.minutes = 0;
            timeObj.seconds = 0;
        }

        return timeObj;
    };

    const extraClass = hasExitIntent ? 'ab-exit-popup' : '';

    const componentDidMount = () => {
        const days = timeObj().days;
        const hours = timeObj().hours;
        const minutes = timeObj().minutes;
        const seconds = timeObj().seconds;
        setDays(days);
        setHours(hours);
        setMinutes(minutes);
        setSeconds(seconds);
    };
    useEffect(() => {
        const id = setInterval(componentDidMount, 1000);
        return () => clearInterval(id);
    }, []);
    useEffect(() => {
        const id = setInterval(setautoClose, closeAutoSeconds * 1000);
        return () => clearInterval(id);
    }, []);

    const renderContent = () => {
        return (
            <div
                className={`ab-offer-new-cnt ${extraClass}`}
                style={popupCntStyles}
            >
                <div
                    className={`css-1b8cm78 ${isMobileClass}`}
                    id="templateViewID"
                    style={{
                        height: 'auto',
                        top: '50%',
                        left: '50%',
                        // transform: 'translate(-50%, -50%)',
                    }}
                >
                    <div
                        className={`ab-popup-new-template${popupTemplate}${mobileClass} popUpBody-class ${
                            hasShadow && 'popUpShadow'
                        }`}
                        id="popUpBody"
                        style={{ backgroundColor: `#${primaryColor}` }}
                    >
                        <div className="ab-offer-new-close">
                            {closeOption ? (
                                <div
                                    className="ab-offer-close-class"
                                    onClick={closePopup}
                                    style={{ color: `#${closeButtonColor}` }}
                                >
                                    SKIP
                                </div>
                            ) : (
                                <button
                                    onClick={closePopup}
                                    className="ab-offer-new-close-button ab-offer-close-class"
                                    tabIndex="0"
                                    type="button"
                                    style={{ color: `#${closeButtonColor}` }}
                                >
                                    <svg
                                        className="ab-popup-new-close-icon"
                                        focusable="false"
                                        aria-hidden="true"
                                        viewBox="0 0 24 24"
                                        data-testid="ClearIcon"
                                    >
                                        <path d="M19 6.41 17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"></path>
                                    </svg>
                                </button>
                            )}
                        </div>
                        <div
                            className="ab-popup-new-image-main popUpImg-class"
                            id="popUpImg"
                            style={{
                                backgroundImage: `url(${imageUrl})`,
                                backgroundPosition: `${imagePosition}% 40%`,
                            }}
                        ></div>
                        <div className="ab-popup-new-body-main ab-popup-new-body">
                            <b
                                id="popUpTitleText"
                                className="popUpTitleText-class ab-popup-new-title-main ab-popup-new-root ab-popup-new-title"
                                style={{ color: `#${titleColor}` }}
                            >
                                {title}
                            </b>
                            <div
                                id="popUpDescriptionText"
                                className="popUpDescriptionText-class ab-popup-new-root ab-popup-new-body-description-main ab-popup-new-font"
                                style={{ color: `#${descriptionColor}` }}
                            >
                                {description}
                            </div>
                            {popupTemplate === 7 && (
                                <div className="ab-popup-new-countdownTimer-main ab-popup-new-countdown">
                                    <div
                                        className="ab-popup-new-countdown-value-outer"
                                        style={{
                                            color: `#${dateTextColor}`,
                                        }}
                                    >
                                        <div
                                            className="ab-popup-new-countdown-value-wrapper"
                                            style={{
                                                width: '47px',
                                                height: '50px',
                                                background: `#${dateBackColor}`,
                                            }}
                                        >
                                            <div className="ab-popup-new-root ab-popup-new-countdown-value">
                                                {days}
                                            </div>
                                        </div>
                                        <div className="ab-popup-new-root ab-popup-new-countdown-value-text">
                                            day
                                        </div>
                                    </div>
                                    <div
                                        className="ab-popup-new-countdown-value-outer"
                                        style={{
                                            color: `#${dateTextColor}`,
                                        }}
                                    >
                                        <div
                                            className="ab-popup-new-countdown-value-wrapper"
                                            style={{
                                                width: '47px',
                                                height: '50px',
                                                background: `#${dateBackColor}`,
                                            }}
                                        >
                                            <div className="ab-popup-new-root ab-popup-new-countdown-value">
                                                {hours}
                                            </div>
                                        </div>
                                        <div className="ab-popup-new-root ab-popup-new-countdown-value-text">
                                            hours
                                        </div>
                                    </div>
                                    <div
                                        className="ab-popup-new-countdown-value-outer"
                                        style={{
                                            color: `#${dateTextColor}`,
                                        }}
                                    >
                                        <div
                                            className="ab-popup-new-countdown-value-wrapper"
                                            style={{
                                                width: '47px',
                                                height: '50px',
                                                background: `#${dateBackColor}`,
                                            }}
                                        >
                                            <div className="ab-popup-new-root ab-popup-new-countdown-value">
                                                {minutes}
                                            </div>
                                        </div>
                                        <div className="ab-popup-new-root ab-popup-new-countdown-value-text">
                                            minutes
                                        </div>
                                    </div>
                                    <div
                                        className="ab-popup-new-countdown-value-outer"
                                        style={{
                                            color: `#${dateTextColor}`,
                                        }}
                                    >
                                        <div
                                            className="ab-popup-new-countdown-value-wrapper"
                                            style={{
                                                width: '47px',
                                                height: '50px',
                                                background: `#${dateBackColor}`,
                                            }}
                                        >
                                            <div className="ab-popup-new-root ab-popup-new-countdown-value">
                                                {seconds}
                                            </div>
                                        </div>
                                        <div className="ab-popup-new-root ab-popup-new-countdown-value-text">
                                            seconds
                                        </div>
                                    </div>
                                </div>
                            )}
                            {buttonBehavior !== 5 && (
                                <a href={buttonLink}>
                                    <button
                                        id="popUpButtonElem"
                                        className="popUpButtonElem-class ab-popup-new-button-main ab-popup-new-button"
                                        tabIndex="0"
                                        type="button"
                                        style={{
                                            backgroundColor: `#${buttonColor}`,
                                            color: `#${buttonTextColor}`,
                                        }}
                                    >
                                        {/* <div
                                            className="ButtonTickAnimation-root css-5z1ihz-ButtonTickAnimation-root"
                                            style={{
                                                opacity: '0',
                                                transition:
                                                    'opacity 500ms ease 0s',
                                            }}
                                        >
                                            <svg
                                                className="ButtonTickAnimation-animatedCheck"
                                                viewBox="0 0 24 24"
                                            >
                                                <path
                                                    d="M4.1 12.7L9 17.6 20.3 6.3"
                                                    fill="none"
                                                ></path>
                                            </svg>
                                        </div> */}
                                        <div
                                            className="ab-popup-new-button-inner"
                                            style={{
                                                opacity: '1',
                                                transition:
                                                    'opacity 0ms ease 0s',
                                            }}
                                        >
                                            <strong className="ab-popup-new-root ab-popup-new-font">
                                                {buttonText}
                                            </strong>
                                        </div>
                                        <span className="MuiButton-endIcon ab-popup-new-right-icon">
                                            <FaChevronRight size={14} />
                                        </span>
                                    </button>
                                </a>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        );
    };

    return (
        <Modal
            animation={animation}
            isOpen={isOpen}
            autoOpen={{
                timeDelay: timeDelay,
                clickCount: clickCount,
                pageScroll: pageScrollPercent,
                hasExitIntent,
            }}
            onClose={() => setIsOpen(true)}
            onOpen={() => setIsOpen(true)}
            onOverlayClick={() => setIsOpen(false)}
            renderContent={renderContent}
            showHeader={false}
            extraBodyClass="ab-modal-transparent-back"
            className="ab-modal-transparent-back"
            closeAutoSeconds={closeAutoSeconds}
        />
    );
};

// TODO: MAKE THIS BETTER
popUpNew.propTypes = {
    props: PropTypes.object,
    imageUrl: PropTypes.string,
    title: PropTypes.string,
    desc: PropTypes.string,
    btnText: PropTypes.string,
    btnUrl: PropTypes.string,
    extraClass: PropTypes.string,
};

export default popUpNew;
